import { render } from "./Introduction.vue?vue&type=template&id=66a1278a"
import script from "./Introduction.vue?vue&type=script&setup=true&lang=js"
export * from "./Introduction.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Commencer/Introduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66a1278a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66a1278a', __exports__)) {
    api.reload('66a1278a', __exports__)
  }
  
  module.hot.accept("./Introduction.vue?vue&type=template&id=66a1278a", () => {
    api.rerender('66a1278a', render)
  })

}


export default __exports__